<template>
    <Modal @modal:dismiss="$emit('dismiss')">
        <h3 slot="header">{{ value.id ? 'Modifier' : 'Créer' }} une session de rattachement</h3>

        <div slot="body">
            <div class="form-control">
                <label>
                    Nom de la session <b>(obligatoire)</b>
                    <CustomInputUniqChecker
                        required
                        class="stretch"
                        v-model="value.name"
                        :err-msg="`Une session nommée ${value.name} existe déjà`"
                        url="/api/check/rattachment/name"
                    />
                </label>
            </div>
            <div class="form-control">
                <label> <b>Paramètres de connexion PostgreSQL :</b> </label>
            </div>
            <div class="form-control">
                <label>
                    Nom d'hôte <b>(obligatoire)</b>
                    <CustomInput required class="stretch" v-model="value.host" />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Port <b>(obligatoire)</b>
                    <CustomInput type="integer" required class="stretch" v-model="value.port" />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Nom de la base de données <b>(obligatoire)</b>
                    <CustomInput required class="stretch" v-model="value.db" />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Utilisateur
                    <CustomInput class="stretch" v-model="value.user" />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Mot de passe de l'utilisateur
                    <CustomInput type="password" class="stretch" v-model="value.pass" />
                </label>
            </div>
            <div class="form-control">
                <label> <b>Paramètres du rattachement :</b> </label>
            </div>
            <div class="form-control">
                <label>
                    Table du filaire à jour [schema.table] <b>(obligatoire)</b>
                    <CustomInput
                        required
                        class="stretch"
                        v-model="value.tablefil"
                        :disabled="value.id"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Table attributaire à rattacher [schema.table] <b>(obligatoire)</b>
                    <CustomInput
                        required
                        class="stretch"
                        v-model="value.tableattr"
                        :disabled="value.id"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Table géométrique à rattacher [schema.table] <b>(obligatoire)</b>
                    <CustomInput
                        required
                        class="stretch"
                        v-model="value.tablegeom"
                        :disabled="value.id"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Nom du schéma pour les tables temporaires <b>(obligatoire)</b> (le schéma
                    <b>doit</b> exister)
                    <CustomInput
                        required
                        class="stretch"
                        v-model="value.schema_temp"
                        :disabled="value.id"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Nom du champ identifiant les données à rattacher <b>(obligatoire)</b>
                    <CustomInput
                        required
                        class="stretch"
                        v-model="value.fid"
                        :disabled="value.id"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Nom du champ contenant la géométrie à rattacher <b>(obligatoire)</b>
                    <CustomInput
                        required
                        class="stretch"
                        v-model="value.fgeom"
                        :disabled="value.id"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Nom des champs communs filaire/table métier géométrique [séparés par une
                    virgule] <b>(obligatoire)</b>
                    <CustomInput required class="stretch" v-model="value.tablefil_attr" />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Nom des champs à visualiser dans l'interface [séparés par une virgule]
                    <b>(obligatoire)</b>
                    <CustomInput required class="stretch" v-model="value.flist" />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Code EPSG du système de coordonnées des données géométriques
                    <b>(obligatoire)</b>
                    <CustomInput
                        type="integer"
                        required
                        class="stretch"
                        v-model="value.epsg"
                        :disabled="value.id"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Tolérance du rattachement automatique [en mètres] <b>(obligatoire)</b>
                    <CustomInput
                        type="decimal"
                        required
                        class="stretch"
                        v-model="value.tolerance"
                    />
                </label>
            </div>
            <div class="form-control" v-show="!!value.id">
                <label> <b>Propriétés de la session :</b> </label>
            </div>
            <div class="form-control" v-show="!!value.id">
                <label>
                    Date d'ouverture de la session
                    <CustomInput disabled class="stretch" v-model="value.startdate" />
                </label>
            </div>
            <div class="form-control" v-show="!!value.id">
                <label>
                    Nom de la table temporaire des données attributaires
                    <CustomInput disabled class="stretch" v-model="value.tableattr_temp" />
                </label>
            </div>
            <div class="form-control" v-show="!!value.id">
                <label>
                    Nom de la table temporaire des données géométriques
                    <CustomInput disabled class="stretch" v-model="value.tablegeom_temp" />
                </label>
            </div>
            <div class="form-control" v-show="!!value.id">
                <label>
                    Date de clôture de la session
                    <CustomInput disabled class="stretch" v-model="value.enddate" />
                </label>
            </div>
        </div>
        <div slot="footer">
            <div class="form-control form-inline">
                <CustomButton class="stretch" @click="$emit('dismiss')">Annuler</CustomButton>
                <CustomButton class="stretch default" @click="$emit('close')">
                    {{ value.id ? 'Enregistrer' : 'Initialiser' }}
                </CustomButton>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from './../Modal';
import CustomInput from './../Input';
import CustomButton from './../Button';
import CustomInputUniqChecker from './../InputUniqChecker';

export default {
    props: ['value'],
    components: {
        Modal,
        CustomInput,
        CustomButton,
        CustomInputUniqChecker,
    },
};
</script>

<style lang="scss"></style>
